export const ASSOC_STORAGE_KEY = "fan_assoc_current_id";
/** 显式绑定的会员 legacyId（可选；未设置时从入会申请本地缓存读取） */
export const CURRENT_MEMBER_LEGACY_ID_KEY = "fan_current_member_legacy_id";

const MEMBER_APP_STORAGE_KEY = "fan_member_application_v2";

function readLegacyIdFromApplication(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(MEMBER_APP_STORAGE_KEY);
    if (!raw) return null;
    const app = JSON.parse(raw) as { memberLegacyId?: string };
    const mid = app.memberLegacyId?.trim();
    return mid || null;
  } catch {
    return null;
  }
}

export function getTenantLegacyId(): string {
  if (typeof window === "undefined") return "";
  return (localStorage.getItem(ASSOC_STORAGE_KEY) ?? "").trim();
}

/** 写入当前协会租户编号（PC 后台登录后必须与 JWT 租户一致）。 */
export function setTenantLegacyId(legacyId: string): void {
  if (typeof window === "undefined") return;
  const next = legacyId.trim();
  if (next) {
    localStorage.setItem(ASSOC_STORAGE_KEY, next);
  } else {
    localStorage.removeItem(ASSOC_STORAGE_KEY);
  }
  window.dispatchEvent(new Event("fan-tenant-context"));
}

export function setCurrentMemberLegacyId(legacyId: string | null): void {
  if (typeof window === "undefined") return;
  if (legacyId?.trim()) {
    localStorage.setItem(CURRENT_MEMBER_LEGACY_ID_KEY, legacyId.trim());
  } else {
    localStorage.removeItem(CURRENT_MEMBER_LEGACY_ID_KEY);
  }
  window.dispatchEvent(new Event("fan-member-context"));
}

/**
 * 会员端接口使用的 legacyId：优先 `fan_current_member_legacy_id`，否则从已成功提交的入会申请记录读取。
 * 未入会、无有效 id 时返回 null（禁止再默认演示账号）。
 */
export function getCurrentMemberLegacyId(): string | null {
  if (typeof window === "undefined") return null;
  const explicit = localStorage.getItem(CURRENT_MEMBER_LEGACY_ID_KEY)?.trim();
  if (explicit) return explicit;
  return readLegacyIdFromApplication();
}
